var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.showUserDetail,"width":"80%"},on:{"update:visible":function($event){_vm.showUserDetail=$event}}},[_c('x-table',{attrs:{"tableData":_vm.tableData,"tableHeaders":_vm.tableHeaders}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }